module.exports = __webpack_public_path__ + "img/PARIBET.0de6dbe6.svg";